<template>
  <div class="vh-100 w-100 relative bg-light-gray">
    <GmapMap
      ref="localMap"
      :center="{
        lat: parseFloat(development.location.lat),
        lng: parseFloat(development.location.lng)
      }"
      :zoom="StartMapZoom"
      :options="map.options"
      map-type-id="roadmap"
      class="bg-dark-gray w-100 h-100"
    >
      <GmapMarker
        :position="{
          lat: parseFloat(development.location.lat),
          lng: parseFloat(development.location.lng)
        }"
        :clickable="true"
        :draggable="false"
        :icon="map.marker[development.brand]"
        @click="center={
          lat: parseFloat(development.location.lat),
          lng: parseFloat(development.location.lng)
        }"
      />
    </GmapMap>
    <Controls
      @filterSelected="filterIcons"
      @clickZoomIn="zoomIn"
      @clickZoomOut="zoomOut"
    />
  </div>
</template>
<script>

import MapStyle from '@/assets/json/gmaps-style.json'
import Controls from '@/components/local-information/Controls.vue'

export default {
  name: 'LocalInformation',
  components: {
    Controls
  },
  data () {
    return {
      tab: 'Location',
      toggle: true,
      map: {
        marker: {
          lh: require('@/assets/img/map-marker-active-lh.png'),
          lq: require('@/assets/img/map-marker-active-lq.png')
        },
        options: {
          zoomControl: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: true,
          fullscreenControl: false,
          disableDefaultUi: false,
          styles: MapStyle,
          scrollwheel: false,
          disableDoubleClickZoom: true
        }
      }
    }
  },
  computed: {
    development () {
      if (this.$store.state.content) {
        return this.$store.getters.getDevelopment('developments/' + this.$route.params.id)
      } else {
        return null
      }
    },
    getFilters () {
      return this.$store.state.local.filters
    },
    googleIconsState () {
      return this.$store.state.local.googleDeafultIcons
    },
    StartMapZoom () {
      return parseInt(this.$store.state.local.startMapZoom)
    }
  },
  methods: {
    zoomIn () {
      this.$store.commit('plusZoomLevel')
    },
    zoomOut () {
      this.$store.commit('minusZoomLevel')
    },

    filterIcons (filterSelected) {
      let option = filterSelected
      // if icon this
      if (filterSelected === 'transport') {
        // if the category does not exsit in the store google maps array
        if (this.getFilters[option]) {
          // build and object to turn it off
          let transportObj = {
            featureType: 'transit',
            elementType: 'labels.icon',
            stylers: [{ visibility: 'off' }]
          }
          this.$store.commit('setGoogleArray', transportObj)
          this.$refs.localMap.$mapPromise.then((map) => {
            map.setOptions({ styles: this.googleIconsState })
          })
          this.toggle = !this.toggle
          // else serach the store for the object and remove it
        } else {
          this.$store.commit('removeFromGoogleArray', 'transit')
          this.$refs.localMap.$mapPromise.then((map) => {
            map.setOptions({ styles: this.googleIconsState })
          })
        }
      } else if (filterSelected === 'schools') {
        if (this.getFilters[option]) {
          let schoolObj = {
            featureType: 'poi.school',
            stylers: [{ visibility: 'off' }]
          }
          this.$store.commit('setGoogleArray', schoolObj)
          this.$refs.localMap.$mapPromise.then((map) => {
            map.setOptions({ styles: this.googleIconsState })
          })
          this.toggle = !this.toggle
        } else {
          this.$store.commit('removeFromGoogleArray', 'poi.school')
          this.$refs.localMap.$mapPromise.then((map) => {
            map.setOptions({ styles: this.googleIconsState })
          })
        }
      } else if (filterSelected === 'leisure') {
        if (this.getFilters[option]) {
          let attractionObj = {
            featureType: 'poi.attraction',
            stylers: [{ visibility: 'off' }]
          }
          let sportsComplexObj = {
            featureType: 'poi.sports_complex',
            stylers: [{ visibility: 'off' }]
          }
          this.$store.commit('setGoogleArray', attractionObj)
          this.$store.commit('setGoogleArray', sportsComplexObj)
          this.$refs.localMap.$mapPromise.then((map) => {
            map.setOptions({ styles: this.googleIconsState })
          })
          this.toggle = !this.toggle
        } else {
          this.$store.commit('removeFromGoogleArray', 'poi.attraction')
          this.$store.commit('removeFromGoogleArray', 'poi.sports_complex')

          this.$refs.localMap.$mapPromise.then((map) => {
            map.setOptions({ styles: this.googleIconsState })
          })
        }
      } else if (filterSelected === 'green_areas') {
        if (this.getFilters[option]) {
          let parkObj = {
            featureType: 'poi.park',
            stylers: [{ visibility: 'off' }]
          }
          this.$store.commit('setGoogleArray', parkObj)
          this.$refs.localMap.$mapPromise.then((map) => {
            map.setOptions({ styles: this.googleIconsState })
          })
          this.toggle = !this.toggle
        } else {
          this.$store.commit('removeFromGoogleArray', 'poi.park')
          this.$refs.localMap.$mapPromise.then((map) => {
            map.setOptions({ styles: this.googleIconsState })
          })
        }
      } else if (filterSelected === 'food_and_drink') {
        if (this.getFilters[option]) {
          this.$store.commit('removeFromGoogleArray', 'poi.business.food_and_drink')
          let foodObj = {
            featureType: 'poi.business.food_and_drink',
            stylers: [{ visibility: 'off' }]
          }
          this.$store.commit('setGoogleArray', foodObj)
          this.$refs.localMap.$mapPromise.then((map) => {
            map.setOptions({ styles: this.googleIconsState })
          })
          this.toggle = !this.toggle
        } else {
          this.$store.commit('removeFromGoogleArray', 'poi.business.food_and_drink')
          let foodObj = {
            featureType: 'poi.business.food_and_drink',
            stylers: [{ visibility: 'on' }]
          }
          this.$store.commit('setGoogleArray', foodObj)
          this.$refs.localMap.$mapPromise.then((map) => {
            map.setOptions({ styles: this.googleIconsState })
          })
        }
      }
    }
  },
  mounted () {
    if (!this.getFilters['food_and_drink']) {
      let foodObj = {
        featureType: 'poi.business.food_and_drink',
        stylers: [{ visibility: 'on' }]
      }
      this.$store.commit('setGoogleArray', foodObj)
      this.$refs.localMap.$mapPromise.then((map) => {
        map.setOptions({ styles: this.googleIconsState })
      })
    }
  }
}
</script>
<style lang="scss">
  .gm-style-iw-a,
  .poi-info-window {
    display: none !important;
    pointer-events: none !important;
  }
  .fade-in-top {
    animation: fade-in-top 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  }
  @keyframes fade-in-top {
    0% {
      transform: translateY(-50px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
</style>
